import styled from '@emotion/styled';
import { Button, ButtonProps, pxToRem, Text } from '@lbcamden/lib-react';
import { Ref } from 'react';

export const ItemDetailsRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(12)};
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacing(8)};
`;

export const TitleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const DetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const TitleLabel = styled(Text)`
  font-size: ${pxToRem(22)};
  font-weight: 300;
  line-height: ${pxToRem(25)};
`;

export const DetailsHeader = styled(Text)`
  ${({ theme }) => theme.text.h2};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)};
`;

const ButtonBase = ({
  ref,
  ...props
}: Omit<ButtonProps, '$variant'> & { ref?: Ref<HTMLButtonElement> }) => (
  <Button ref={ref} $color="secondary" {...props} />
);

export const ItemActionButton = styled(ButtonBase)`
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;

  svg {
    flex-shrink: 0;
    height: ${pxToRem(18)};
  }
`;

export const InfoGrid = styled.dl`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: ${({ theme }) => theme.spacing(4)};
  padding: ${({ theme }) => theme.spacing([2, 0])};
  margin: 0;

  dt {
    display: flex;
    flex-wrap: nowrap;
  }

  dt,
  dd {
    min-width: 100%;
    margin: 0;
    word-wrap: break-word;
    white-space: pre-wrap;
  }
`;

export const InfoList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;

  li:not(:last-child) {
    padding-bottom: ${({ theme }) => theme.spacing(1)};
  }
`;
